import { IItemCache } from '../models/IItemCacheObserver';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { ItemCacheObserver, IItemCacheDependencies, IItemCacheDemands } from '../models/itemCache/ItemCacheObserver';

/**
 * @public
 */
export function readItems<T>(readDataFromItemCache: (itemCache: IItemCache) => T): IItemCacheThunkAction<T> {
  return (dispatch: IItemCacheDispatch, getState: () => IItemCacheState) => {
    let previousDependencies: IItemCacheDependencies | undefined;
    let previousDemands: IItemCacheDemands | undefined;

    let result: T;

    let itemCache = new ItemCacheObserver({
      state: getState(),
      dispatch: dispatch,
      previousDependencies: previousDependencies,
      previousDemands: previousDemands
    });

    try {
      ({
        result
      } = itemCache.evaluate(readDataFromItemCache));
    } finally {
      itemCache.dispose();
    }

    return result;
  };
}
